export default {
  enableLongCutOrientation: false,
  enableRightBinding: true,
};
